import Vue from "vue";
import Vuex from "vuex";

// modules
import auth from "./auth";
import customerSucess from "./customerSuccess";
import common from "./common";
import product from "./product";
import marketing from "./marketing";
import dashboard from "./dashboard";
import devops from "./devops";
import enterprise from "./enterprise";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const store = new Vuex.Store({
  modules: {
    auth,
    customerSucess,
    product,
    marketing,
    common,
    dashboard,
    devops,
    enterprise
  },
  strict: debug,
});

export const useStore = () => store;

export default store;
